import React from 'react';

const PrivateConfidentialComponent = () => {
    return (
        <section className="as_about_wrapper as_padderTop80 as_padderBottom80">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 col-md-12">
                        <h1 className="as_heading text-center">Private & Confidential</h1>
                        <div className="as_font14 as_padderTop20" style={{lineHeight: '1.8'}}>
                            <p><b>At Astroscope, your privacy is our utmost priority.</b></p>
                            <h2>Confidentiality of Your Data</h2>
                            <p>All personal information, conversations, and data shared on our platform are treated with the highest level of confidentiality. We do not sell, rent, or share your personal data with any third parties without your explicit consent, except as required by law.</p>
                            <h2>Secure Communication</h2>
                            <p>All chats and consultations between you and our astrologers are encrypted and stored securely. Only you and your astrologer have access to your conversation history.</p>
                            <h2>Data Protection</h2>
                            <p>We use advanced security protocols and regularly update our systems to protect your information from unauthorized access, loss, or misuse.</p>
                            <h2>Your Control</h2>
                            <p>You have full control over your account and personal information. You can update or delete your data at any time through your profile settings.</p>
                            <h2>Our Commitment</h2>
                            <p>We are committed to maintaining your trust and confidence. If you have any concerns about your privacy or data security, please contact our support team for assistance.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default PrivateConfidentialComponent; 